export function createVintageRange(
  baseYear = 2016,
  numEntries = 50,
): Array<string> {
  return [...Array(numEntries)].map((_, i) => (baseYear + i).toString())
}
